/**
 * ErrorState — the placeholder for a load that FAILED (#457).
 *
 * A failed load is a third state, not an empty list and not a loading
 * skeleton. Before this component, a failed request showed "No tournaments"
 * or a skeleton that never ended, so on venue Wi-Fi a user could not tell
 * "nothing here" from "the request did not arrive".
 *
 * Give `onRetry` whenever the caller can load again: the button is the
 * user's only way out without a page reload.
 *
 * #661 — the card is an `EmptyState` with `role="alert"`: one shell for both.
 */
import { useI18n } from '../../i18n';
import EmptyState from './EmptyState';

interface ErrorStateProps {
  onRetry?: () => void;
  /** Tighter padding for in-page sub-panels. Default: roomy. */
  compact?: boolean;
}

export default function ErrorState({ onRetry, compact = false }: ErrorStateProps) {
  const { t } = useI18n();
  return (
    <EmptyState compact={compact} role="alert" testId="error-state"
      title={t.common.loadFailed} hint={t.common.loadFailedHint}
      action={onRetry && (
        <button type="button" className="btn-outline" onClick={onRetry} data-testid="error-state-retry">
          {t.common.retry}
        </button>
      )} />
  );
}
